import _ from 'lodash';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

export const renderComponent = (el, componentMap = {}, store) => {
  const attributes = Array.prototype.slice.call(el.attributes);
  const dataAttributes = attributes.reduce((result, attr) => {
    const name = attr.name;
    if (name.indexOf('data-') !== 0) {
      return result;
    }

    return {
      ...result,
      [_.camelCase(name.substr(5))]: attr.value,
    };
  }, {});

  const { componentName, ...props } = dataAttributes;

  if (componentMap[componentName]) {
    const component = { element: componentMap[componentName] };
    if (store) {
      render(
        <Provider store={store}>
          <component.element {...props} />
        </Provider>,
        el,
      );
    } else {
      render(<component.element {...props} />, el);
    }
  }
};

export const renderAll = (componentMap = {}, store) => {
  Array.prototype.slice.call(document.querySelectorAll('.react-component'))
    .forEach(el => renderComponent(el, componentMap, store));
};
